import Head from "next/head";
import { usePathname } from "next/navigation";

function CanonicalUrl({ forcePath = false, forcedPath = "/" }) {
  const pathname = usePathname();

  const href = () => {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
    const path = forcePath ? forcedPath : pathname;

    return `${baseUrl}${path}`;
  };

  return (
    <Head>
      <link
        rel="canonical"
        href={href()}
        data-testid="canonical-url"
      />
    </Head>
  );
}

export default CanonicalUrl;
